var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FeathersServiceTable", {
    attrs: {
      service: "cases",
      params: _vm.casesParams,
      headers: _vm.tableHeaders,
      limit: 10,
    },
    scopedSlots: _vm._u([
      {
        key: "item.name",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "router-link",
              {
                attrs: {
                  to: {
                    name: "CaseInput",
                    params: { scenario: item.scenario, id: item.id },
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.name) + " ")]
            ),
          ]
        },
      },
      {
        key: "item.deleted",
        fn: function (ref) {
          var item = ref.item
          return [_c("span", [_vm._v(_vm._s(_vm.formatDate(item.deleted)))])]
        },
      },
      {
        key: "item.directory_id",
        fn: function (ref) {
          var item = ref.item
          return [
            item.directory_id !== null
              ? _c("FeathersVuexGet", {
                  attrs: { service: "directories", id: item.directory_id },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var folder = ref.item
                          return [
                            folder
                              ? _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "Folders",
                                        params: { folderId: item.directory_id },
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(folder.name) + " ")]
                                )
                              : _c("span", [_vm._v("Loading...")]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              : _c("router-link", { attrs: { to: { name: "Folders" } } }, [
                  _vm._v(" Root Folder "),
                ]),
          ]
        },
      },
      {
        key: "item.actions",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "v-tooltip",
              {
                attrs: { top: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.restoreCase(item.id)
                                    },
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-delete-restore")])],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              [_c("span", [_vm._v("Restore")])]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }